import { Table, Col } from "antd";
import React, { useEffect, useMemo } from "react";
import ZCard from "../../../Card/Index";
import DataFormatter from "../../../common/DataFormatter";
import { getSummaryDetails } from "../../../../api/reportDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  setSummaryData,
  setSummaryLoading,
} from "../../../../store/reducers/slices/summary.slice";
import {
  CurrencyFormatWithDecimal,
  CurrencyFormatWithoutDecimal,
} from "../../../../helper/CurrencyFormate";
import { CURRENCY } from "../../../../utils/ConstantData";
import CustomAmountText from "../../../common/CustomAmountText";
import { bankAccountsArray } from "../../../../utils/format";
import styles from "./reportTabs.module.scss";
import {
  setTxnEndDate,
  setTxnStartDate,
} from "../../../../store/reducers/slices/availableBalance.slice";

const SummaryReport = () => {
  const { isLoading, summaryList } = useSelector((state) => state.summary);
  const { selectedAccountId, reportDetails } = useSelector(
    ({ reportDetails }) => reportDetails
  );
  const dispatch = useDispatch();

  const sectionData = summaryList.filter(
    (item) => item.sectionName === "Bank Accounts"
  );
  const setValueArray = sectionData.filter(
    (item) => item.setId !== sectionData[0].setId
  );
  const labels = sectionData.length > 0 ? sectionData[0].sectionValues : [];
  const values = sectionData.slice(1).map((item) => item.sectionValues);

  const setValues = setValueArray.map((item) => item.setValue);

  // console.log("VALUES:>>>", values);
  // console.log("LABELS:>>>>", labels);

  const column = [
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 200,
      className: "table-column-1 w-50",
    },
    ...(setValues.map((_, index) => ({
      title: `Account ${index + 1}`,
      dataIndex: `account${index + 1}`,
      key: `account${index + 1}`,
    })) || []),
  ];

  const dataSource = labels.map((label) => {
    const rowData = {
      description: label.value,
    };

    values.forEach((value, index) => {
      const foundValue = value.find((v) => v.key === label.key);
      rowData[`account${index + 1}`] = foundValue ? foundValue.value : "-";
    });

    return rowData || {};
  });

  const topRow = {
    description: "Description",
  };

  setValues.forEach((setValue, index) => {
    topRow[`account${index + 1}`] = setValue; // Set the value for each account's setValue
  });

  const updatedDataSource = [topRow, ...dataSource];

  // console.log("SUMMARY LIST::::::", updatedDataSource);

  // const accountCol = [
  //     {
  //       title: 'Label',
  //       dataIndex: 'label',
  //       key: 'label',
  //       width: 200,
  //       className: "table-column-1 w-50"
  //     },
  //     ...reportDetails?.reportAccounts?.map((_, index) => ({
  //       title: `Account ${index + 1}`,
  //       dataIndex: `${index}`,  // Just the index for the dataIndex
  //       key: `${index}`,
  //       className: "table-column-2 w-50"  // Use the index as the key too
  //     })) || [],
  // ];

  // const bankAccountDataArr = useMemo(() => {
  //     if(Object.keys(reportDetails).length > 0){
  //         let newList = bankAccountsArray(reportDetails?.reportAccounts)
  //         return newList
  //     }
  //     return [];
  // }, [reportDetails])

  // console.log("BANK ACCOUNT DATA:::", bankAccountDataArr);

  useEffect(() => {
    console.log("Under UE");

    if (selectedAccountId) {
      console.log("selectedAccountId", selectedAccountId);
      dispatch(setSummaryLoading(true));
      fetchData(selectedAccountId);
    }
  }, [selectedAccountId, dispatch]);

  console.log("SUMMARY SELECTED ACCOUNT::::::", selectedAccountId);
  // console.log("SUMMARY REPORT DETAILS::::::", reportDetails);

  const createList = (valueStr) => {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          maxWidth: 400,
        }}
      >
        {valueStr.split("\n").map((fileName, index) => (
          <span key={index}>{fileName}</span>
        ))}
      </div>
    );
  };

  const fetchData = (accountId) => {
    let aggregate = accountId !== "all" ? false : true;
    let account_id = accountId !== "all" ? accountId : reportDetails?.report?.reportId;
    getSummaryDetails(account_id, aggregate)
      .then((resp) => {
        console.log("resp", resp);
        dispatch(setSummaryData(resp));
        dispatch(setSummaryLoading(false));
      })
      .catch((error) => {
        // alert(`${error.message}`);
        dispatch(setSummaryLoading(false));
      });
  };

  const { data, columns } = useMemo(() => {
    let columns = [];
    const data = [];

    const currencyCode = "INR";
    const uniqueSection = summaryList
      .map((obj) => obj.section)
      .filter((value, index, self) => self.indexOf(value) === index);

    uniqueSection.forEach((secNum, index) => {
      if (secNum !== 1002) return;

      const sectionWiseList = summaryList.filter(
        (obj) => obj.section === secNum
      );
      const headerList = sectionWiseList.map((obj) => obj.setValue);
      const headerType = sectionWiseList.map((obj) => obj.type);

      const firstColumn =
        sectionWiseList[0].sectionName === "Monthwise details"
          ? currencyCode === "INR"
            ? sectionWiseList[0].sectionValues.map((obj) => obj.key)
            : sectionWiseList[0].sectionValues
              .map((obj) => obj.key)
              .filter(
                (value) =>
                  value !== "NEFT Returns" &&
                  value !== "ECS/NACH Issued Count" &&
                  value !== "ECS/NACH Issued"
              )
          : sectionWiseList[0].sectionValues.map((obj) => obj.key);

      firstColumn.map((ele, index) => {
        const rowData = sectionWiseList.map((obj) =>
          obj.sectionValues.find((val) => val.key === ele)
        );

        columns = headerList.map((v, i) => {
          return {
            title: v,
            ...(i === 0 ? { fixed: "left", width: 250 } : { width: 160 }),
            key: i,
            render: (text, record, index) => {
              return record[i].type === "AMOUNT" ? (
                <CustomAmountText
                  shouldDisplayCurrency={true}
                  value={record[i].value}
                />
              ) : record[i].type === "COUNT" ? (
                CurrencyFormatWithoutDecimal(record[i].value)
              ) : record[i].type === "LIST" ? (
                createList(record[i].value)
              ) : (
                record[i].value
              );
            },
          };
        });

        data.push(rowData);
      });
    });

    return { data, columns };
  }, [summaryList]);
  return (
    <>
      {selectedAccountId === "all" ? (
        <>
          <ZCard style={{ marginBottom: "20px" }}>
            <ZCard.Title level={5} className={`${styles.zCardTitle}  pl-16`}>
              All Bank Accounts
            </ZCard.Title>
            <Table
              columns={column}
              showHeader={false}
              loading={isLoading}
              dataSource={updatedDataSource}
              pagination={false}
              scroll={{
                y: 425,
              }}
            />
          </ZCard>
        </>
      ) : (
        ""
      )}
      <ZCard>
        <Table
          loading={isLoading}
          columns={columns}
          dataSource={data}
          scroll={{ x: 500, y: "calc(100vh - 96px)" }}
          pagination={false}
        />
      </ZCard>
    </>
  );
};

export default SummaryReport;
